import { DocumentType } from 'us.collection.routines-and-activities/constants';
import { DocumentDrawer } from 'us.collection.routines-and-activities/interfaces';

export enum FilterOptionValues {
	ALL = 'all',
	ACTIVITIES = 'activities',
	MESSAGES = 'messages',
	CASELOGS = 'caseLogs',
	CP_NOTES = 'cpnote',
	DP_NOTES = 'dpnote',
	EVENTS= "event"
}

export const typeList = [
	{
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.EMAIL',
		value: DocumentType.EMAIL,
	},
	{
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.PDF',
		value: DocumentType.PDF,
	},
	{
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.SMS',
		value: DocumentType.SMS,
	},
	{
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.TEXT',
		value: DocumentType.TEXT,
	},
	,
	{
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.XML',
		value: DocumentType.XML,
	},
];

export const filterOptions = [
	{
		value: FilterOptionValues.ALL,
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.ALL',
		style: { marginRight: '0.5rem' },
	},
	{
		value: FilterOptionValues.ACTIVITIES,
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.ACTIVITY',
		style: { marginRight: '0.5rem' },
	},
	{
		value: FilterOptionValues.MESSAGES,
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.MESSAGE',
		style: { marginRight: '0.5rem' },
	},
	{
		value: FilterOptionValues.CASELOGS,
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.NOTE',
		style: { marginRight: '0.5rem' },
	},
	{
		value: FilterOptionValues.CP_NOTES,
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.CP_NOTES',
		style: { marginRight: '0.5rem' },
	},
	{
		value: FilterOptionValues.DP_NOTES,
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.DEBTOR_NOTE',
		style: { marginRight: '0.5rem' },
	},
	{
		value: FilterOptionValues.EVENTS,
		label: 'US.COLLECTION.ROUTINESANDACTIVITIES:HISTORY.EVENTS',
		style: { marginRight: '0.5rem' },
	},
];

export const DOCUMENT_DRAWER_DEFAULT: DocumentDrawer = {
	documentType: DocumentType.UNKNOWN,
	isVisible: false,
	title: '',
	data: {},
};
